(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deltashop-configurator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeConfigurators = () => {
    document.querySelectorAll('.ds-configurator:not([data-ready])').forEach((root) => {
      root.dataset.ready = 'true';

      const displayLabel = value => ({'Noir x Noir':'أسود وأسود','Blanc x Blanc':'أبيض وأبيض','Gris x Noir':'رمادي وأسود','Rose x Blanc':'وردي وأبيض','Blue + Blanc':'أزرق وأبيض','Echri 1 (Droite)':'قطعة (يمين)','Echri 2 (Gauche + Droite)':'قطعتان (يمين + يسار)'})[value] || value;
      const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
      const variantImages = JSON.parse(root.querySelector('[data-variant-images]').textContent);
      const optionGroups = [...root.querySelectorAll('[data-option-index]')];
      const selected = optionGroups.map((group) => group.querySelector('.is-selected')?.dataset.value || group.querySelector('button')?.dataset.value);
      const variantInput = root.querySelector('.ds-configurator__variant-id');
      const image = root.querySelector('.ds-configurator__image');
      const caption = root.querySelector('.ds-configurator__caption');
      const title = root.querySelector('.ds-configurator__variant-title');
      const price = root.querySelector('.ds-configurator__price');
      const promo = root.querySelector('.ds-configurator__promo');
      const promoPercent = root.querySelector('.ds-configurator__promo-percent');
      const recapImage = root.querySelector('.ds-configurator__recap-image');
      const recapModel = root.querySelector('.ds-configurator__recap-model');
      const recapColor = root.querySelector('.ds-configurator__recap-color');
      const recapPrice = root.querySelector('.ds-configurator__recap-price');
      const recapCompare = root.querySelector('.ds-configurator__recap-compare');
      const steps = root.querySelectorAll('.ds-configurator__steps li');
      const formHost = root.querySelector('.ds-configurator__product-form');
      const enhanceOrderForm = () => {
        const fieldLabels = { first_name: 'الاسم الكامل', phone: 'رقم الهاتف', province: 'الولاية', city_country_field: 'البلدية' };
        let completed = 0;
        Object.entries(fieldLabels).forEach(([id, text]) => {
          const field = formHost.querySelector(`[id="${id}"]`);
          if (!field) return;
          const label = formHost.querySelector(`label[for="${id}"]`);
          if (label && label.dataset.dsLabel !== text) {
            label.textContent = text;
            label.dataset.dsLabel = text;
          }
          field.setAttribute('aria-label', text);
          if (field.tagName === 'SELECT' && field.options[0] && ['Wilaya','Baladiya'].includes(field.options[0].text)) field.options[0].text = text;
          if (id === 'first_name') field.setAttribute('autocomplete', 'name');
          if (id === 'phone') { field.setAttribute('dir', 'ltr'); field.setAttribute('autocomplete', 'tel'); field.setAttribute('inputmode', 'tel'); }
          if (field.value.trim()) completed++;
        });
        const progress = root.querySelector('.ds-order-progress');
        const progressText = `${completed} / 4`;
        if (progress.textContent !== progressText) progress.textContent = progressText;
        const shippingHeading = formHost.querySelector('.rsi-shipping-rates-label');
        if (shippingHeading) { shippingHeading.setAttribute('role', 'heading'); shippingHeading.setAttribute('aria-level', '3'); }
      };
      new MutationObserver(enhanceOrderForm).observe(formHost, { childList: true, subtree: true });
      formHost.addEventListener('input', enhanceOrderForm);
      formHost.addEventListener('change', enhanceOrderForm);
      enhanceOrderForm();
      const currency = new Intl.NumberFormat('ar-DZ-u-nu-latn', { style: 'currency', currency: window.Shopify?.currency?.active || 'DZD' });

      let imageRequest = 0;
      const transitionImage = async (next, variantId) => {
        if (image.dataset.imageVariant === String(variantId)) return;
        const request = ++imageRequest;
        const nextUrl = new URL(next.src, document.baseURI).href;
        if (image.src === nextUrl) {
          image.dataset.imageVariant = String(variantId);
          return;
        }
        const preload = new Image();
        preload.src = next.src;
        try { await preload.decode(); } catch { return; }
        if (request !== imageRequest) return;
        if (request !== imageRequest) return;
        image.removeAttribute('srcset');
        image.src = next.src;
        image.dataset.imageVariant = String(variantId);
        image.alt = 'مسند المعصم المريح المتحرك';
      };
      const updateVariant = () => {
        const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        title.textContent = selected.map(displayLabel).join(' / ');
        caption.textContent = displayLabel(selected[1] || variant.public_title || variant.title);
        price.textContent = currency.format(variant.price / 100);
        const hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
        promo.hidden = !hasDiscount;
        if (hasDiscount) promoPercent.textContent = `وفّر ${Math.round((1 - variant.price / variant.compare_at_price) * 100)}%`;
        recapModel.textContent = displayLabel(selected[0] || '').split('(')[0].trim();
        recapModel.title = displayLabel(selected[0] || '');
        recapColor.textContent = '';
        recapColor.setAttribute('role', 'img');
        recapColor.setAttribute('aria-label', displayLabel(selected[1] || ''));
        recapColor.title = displayLabel(selected[1] || '');
        recapPrice.textContent = currency.format(variant.price / 100);
        recapCompare.hidden = !hasDiscount;
        recapCompare.textContent = hasDiscount ? currency.format(variant.compare_at_price / 100) : '';
        const colorButton = optionGroups[1]?.querySelector('.is-selected');
        const swatch = colorButton?.querySelector('.ds-configurator__swatch');
        if (swatch) {
          const selectedColor = getComputedStyle(swatch).getPropertyValue('--swatch');
          caption.style.setProperty('--selected-swatch', selectedColor);
          recapColor.style.background = selectedColor;
        }
        const variantImage = variantImages[String(variant.id)];
        if (variantImage?.src) {
          transitionImage(variantImage, variant.id);
          recapImage.src = variantImage.src.replace(/([?&])width=\d+/, '$1width=120');
          recapImage.alt = variantImage.alt;
        }
        const variantUrl = new URL(window.location.href);
        variantUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', variantUrl);
      };

      optionGroups.forEach((group, index) => {
        group.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
          group.querySelectorAll('button').forEach((item) => { item.classList.remove('is-selected'); item.setAttribute('aria-pressed', 'false'); });
          button.classList.add('is-selected');
          button.setAttribute('aria-pressed', 'true');
          selected[index] = button.dataset.value;
          updateVariant();
        }));
      });

      const setStep = (step) => {
        if (step === 2) document.dispatchEvent(new Event('ds:order-open'));
        root.dataset.step = String(step);
        root.querySelector('.ds-configurator__cod-panel').setAttribute('aria-hidden', step === 2 ? 'false' : 'true');
        root.querySelector('.ds-configurator__choice-panel').setAttribute('aria-hidden', step === 2 ? 'true' : 'false');
        root.querySelector('.ds-configurator__back-icon').disabled = step === 1;
        steps.forEach((item, index) => item.classList.toggle('is-active', index + 1 === step));
        if (step === 2) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        window.scrollTo({ top: 0, behavior: 'smooth' });
      };

      root.querySelector('.ds-order-buy').addEventListener('click', () => {
        const panel = root.querySelector('.ds-configurator__cod-panel');
        const form = root.querySelector('.ds-configurator__product-form');
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        if (getComputedStyle(panel).overflowY === 'auto') panel.scrollTo({ top: panel.scrollTop + form.getBoundingClientRect().top - panel.getBoundingClientRect().top - 16, behavior });
        else form.scrollIntoView({ block: 'center', behavior });
      });
      root.querySelector('.ds-configurator__continue').addEventListener('click', () => setStep(2));
      root.querySelectorAll('.ds-configurator__back, .ds-configurator__back-icon').forEach((button) => button.addEventListener('click', () => setStep(1)));
      updateVariant();
      if (window.Shopify?.designMode) setStep(Number(root.dataset.editorStep) || 1);
    });
    };
    initializeConfigurators();
    document.addEventListener("shopify:section:load", initializeConfigurators);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fussy-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const header = document.querySelector('.fussy-header--overlay');
  if (!header) return;
  const update = () => header.classList.toggle('is-scrolled', window.scrollY > 28);
  window.addEventListener('scroll', update, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fussy-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-home-prev],[data-home-next]');
  if (!button) return;
  const track = button.closest('.fussy-products').querySelector('.fussy-product-grid');
  track.scrollBy({left: track.clientWidth * (button.hasAttribute('data-home-next') ? -1 : 1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fussy-split"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => { const button = event.target.closest('.fussy-video-toggle'); if (!button) return; const video = button.parentElement.querySelector('video'); if (video.paused) { video.play(); button.textContent = 'Ⅱ'; } else { video.pause(); button.textContent = '▶'; } });
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) document.querySelectorAll('.fussy-split video').forEach(video => video.pause());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
